import React from 'react';
import { ArrowRight } from 'lucide-react';
export function QuickActionCards() {
  return <section className="pt-32 pb-20 bg-white" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-12" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-semibold text-brand-blue mb-4" data-id="element-148">
            Ready to Transform Your Home?
          </h2>
          <p className="text-lg text-brand-gray max-w-2xl mx-auto font-body" data-id="element-149">
            Whether you're planning a kitchen remodel, bathroom upgrade, or
            complete home renovation, we're here to bring your vision to life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-150">
          {/* Primary CTA */}
          <a href="#contact" className="group relative overflow-hidden bg-brand-blue hover:bg-opacity-90 p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1" data-id="element-151">
            <div className="relative z-10" data-id="element-152">
              <div className="text-white/80 text-sm font-semibold mb-2 uppercase tracking-wider" data-id="element-153">
                Start Your Project
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3" data-id="element-154">
                Get a Free Quote
              </h3>
              <p className="text-white/90 mb-6 font-body" data-id="element-155">
                No obligation estimate. We'll discuss your vision, timeline, and
                budget.
              </p>
              <div className="inline-flex items-center text-white font-semibold group-hover:gap-3 gap-2 transition-all" data-id="element-156">
                Request Quote
                <ArrowRight className="w-5 h-5" data-id="element-157" />
              </div>
            </div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16" data-id="element-158"></div>
          </a>

          {/* Secondary CTA */}
          <a href="#gallery" className="group relative overflow-hidden bg-white border-2 border-brand-blue p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1 hover:bg-brand-blue" data-id="element-159">
            <div className="relative z-10" data-id="element-160">
              <div className="text-brand-blue/70 group-hover:text-white/80 text-sm font-semibold mb-2 uppercase tracking-wider transition-colors" data-id="element-161">
                Our Portfolio
              </div>
              <h3 className="text-2xl font-semibold text-brand-blue group-hover:text-white mb-3 transition-colors" data-id="element-162">
                See Our Work
              </h3>
              <p className="text-brand-blue/80 group-hover:text-white/90 mb-6 font-body transition-colors" data-id="element-163">
                Browse completed projects and see the quality craftsmanship we
                deliver.
              </p>
              <div className="inline-flex items-center text-brand-blue group-hover:text-white font-semibold group-hover:gap-3 gap-2 transition-all" data-id="element-164">
                View Gallery
                <ArrowRight className="w-5 h-5" data-id="element-165" />
              </div>
            </div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16" data-id="element-166"></div>
          </a>
        </div>

        {/* Call Direct Option */}
        <div className="mt-8 text-center" data-id="element-167">
          <p className="text-brand-gray mb-3 font-body" data-id="element-168">
            Prefer to talk? Call us directly:
          </p>
          <a href="tel:559-288-0499" className="inline-flex items-center gap-2 text-2xl font-semibold text-brand-blue hover:opacity-80 transition-colors" data-id="element-169">
            <Phone className="w-6 h-6" data-id="element-170" />
            <span className="font-semibold" data-id="element-171">559-288-0499</span>
          </a>
        </div>
      </div>
    </section>;
}
function Phone(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-172">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-173"></path>
    </svg>;
}